import { Divider, Menu, MenuItem } from '@mui/material';
import React, { useState } from 'react';

import Icon from '@/components/icon';

const RowMoreOptions = ({ items, onShow, style }) => {
  const [showPopover, setShowPopover] = useState(false);
  const [anchorElement, setAnchorElement] = useState(null);

  const togglePopover = (event) => {
    setAnchorElement(event.currentTarget);
    setShowPopover(!showPopover);
  };

  const closePopover = () => {
    setShowPopover(false);
    setAnchorElement(null);
  };

  return (
    <div style={{ display: 'inline', ...style }}>
      <Icon
        name="more-vertical"
        aria-label="more"
        aria-controls="long-menu"
        aria-owns={anchorElement ? 'long-menu' : null}
        aria-haspopup="true"
        className="dropbtn"
        style={{
          cursor: 'pointer',
          color: '#2b2b2b',
          padding: 0,
          display: 'inline',
          height: 18,
          width: 18,
        }}
        onClick={togglePopover}
      />

      <Menu
        id="long-menu"
        open={Boolean(anchorElement)}
        anchorEl={anchorElement}
        onClose={closePopover}
        onEntered={onShow}
      >
        {items.map((item, index) => {
          if (item.type === 'MenuItem') {
            return (
              <MenuItem
                key={index}
                onClick={() => {
                  item.onClick();
                  closePopover();
                }}
                style={item.style}
              >
                {item.title}
              </MenuItem>
            );
          }
          if (item.type === 'Divider') {
            return <Divider key={index} />;
          }
          return null;
        })}
      </Menu>
    </div>
  );
};

export default RowMoreOptions;
